'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    function init() {

        if (!$('.hero-wrapper picture').length) {
            context.parent().before(context);
        }
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/language-select.js
// module id = 282
// module chunks = 0